import Axios from "axios";

export const issuingReportApi = ({
    userId,
    merchantId,
    memberName,
    merchantName,
    userName,
    refId,
    startDate,
    endDate,
    pageSize,
    page,
    authToken,
    deviceId,
    pointType,
    availableDate,
    orderBy,
    orderType
}) => {
    if (authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (page > 0) {
            mulai = pageSize + 1;
            baris = 0;
            for (var i = 0; i <= page; ) {
                baris = pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }

        return Axios({
            method: "get",
            url: window.ApiURL + "report/v2/report/issuing",
            params: {
                memberId: userId,
                // merchantId: merchantId,
                merchantName: merchantName,
                memberName: memberName,
                username: userName,
                refId: refId,
                startDate: startDate,
                endDate: endDate,
                offset: mulai,
                pageSize: pageSize,
                page: page,
                nRecords: pageSize,
                pointType: pointType,
                availableDate: availableDate,
                orderBy: orderBy,
                orderType: orderType
            },
            data: {},
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const redeemReportApi = ({
    userId,
    merchantId,
    memberName,
    userName,
    transactionId,
    startDate,
    endDate,
    page,
    pageSize,
    authToken,
    deviceId
}) => {
    if (authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (page > 0) {
            mulai = pageSize + 1;
            baris = 0;
            for (var i = 0; i <= page; ) {
                baris = pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v2/report/redeem",
            params: {
                memberId: userId,
                // merchantId: merchantId,
                memberName: memberName,
                username: userName,
                transactionId: transactionId,
                startDate: startDate,
                endDate: endDate,
                offset: mulai,
                pageSize: pageSize,
                page: page,
                nRecords: pageSize
            },
            data: {},
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const memberBalanceApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v2/report/member-balance",
            params: {
                memberId: data.memberId !== undefined ? data.memberId : (data.userId || ""),
                merchantId: data.merchantId || "",
                memberName: data.memberName || "",
                username: data.userName || data.username || "",
                startDate: data.startDate || undefined,
                endDate: data.endDate || undefined,
                offset: mulai,
                pageSize: data.pageSize || 10,
                page: data.page || 0,
                nRecords: data.pageSize || 10,
                orderType: 1
            },
            data: {},
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId || "Portal"
            }
        });
    }
};

export const voucherBalanceApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v2/report/voucher-balance",
            params: {
                memberId: data.userId,
                // merchantId: data.merchantId,
                memberName: data.memberName,
                productName: data.productName,
                username: data.userName,
                transactionId: data.transactionId,
                status: data.status,
                offset: mulai,
                pageSize: data.pageSize,
                page: data.page,
                nRecords: data.pageSize,
                isOwnProduct: data.isOwnProduct,
                statusList: data.statusList,
                voucherId: data.voucherId,
                voucherCode: data.voucherCode,
                isVoucherCodeEncrypt: data.isVoucherCodeEncrypt,
                startDate: data.startDate,
                endDate: data.endDate
            },
            data: {},
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const referralReportApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/referral-member",
            params: {
                memberId: data.userId,
                merchantId: data.merchantId,
                memberName: data.memberName,
                username: data.userName,
                startDate: data.startDate,
                endDate: data.endDate,
                offset: mulai,
                pageSize: data.pageSize,
                page: data.page,
                nRecords: data.pageSize
            },
            data: {},
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const pointTransactionApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v2/report/point-transaction",
            params: {
                memberId: data.userId,
                // merchantId: data.merchantId,
                trxType: data.trxType,
                memberName: data.memberName,
                username: data.userName,
                refId: data.refId,
                startDate: data.startDate,
                endDate: data.endDate,
                offset: mulai,
                pageSize: data.pageSize,
                page: data.page,
                nRecords: data.pageSize,
                pointType: data.pointType,
                availableDate: data.availableDate
            },
            data: {},
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const pointTransferApi = data => {
    if (data.authToken != null) {
        // var mulai = 0;
        // var baris = 20;

        // if(page>0){
        //     mulai= pageSize + 1;
        //     baris=0;
        //     for(var i=0;i<=page;){
        //         baris = pageSize + baris;
        //         i++;
        //     }
        //     mulai = baris - 20 + 1;
        // }
        return Axios({
            method: "get",
            url: window.ApiURLNew + "point-transaction/point/transfer/history",
            params: {
                userId: data.userId,
                merchantId: data.merchantId,
                username: data.userName,
                memberEmail: data.memberEmail,
                orderBy: "",
                orderType: 1,
                page: data.page,
                nRecords: data.pageSize,
                role: 1,
                startDate: data.startDate,
                endDate: data.endDate
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const reportPartnerApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURLNew + "report/report-partner",
            params: {
                memberId: data.userId,
                merchantId: data.merchantId,
                memberName: data.memberName,
                productName: data.productName,
                offset: mulai,
                pageSize: data.pageSize,
                page: data.page,
                nRecords: data.pageSize,
                merchantIdPartner: data.merchantIdPartner
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const pointsTransactionHistoryReportApi = ({
    userId,
    merchantId,
    accountNumber,
    startDate,
    endDate,
    page,
    pageSize,
    authToken,
    deviceId
}) => {
    // export const pointsTransactionHistoryReportApi = (data) => {
    if (authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (page > 0) {
            mulai = pageSize + 1;
            baris = 0;
            for (var i = 0; i <= page; ) {
                baris = pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURLNew + "report/points-transaction-history",
            params: {
                memberId: userId,
                merchantId: merchantId,
                startDate: startDate,
                endDate: endDate,
                offset: mulai,
                pageSize: pageSize,
                page: page,
                nRecords: pageSize,
                rmNumber: accountNumber
            },
            data: {},
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const pointsVoucherRedemption1ReportApi = ({
    userId,
    merchantId,
    accountNumber,
    startDate,
    endDate,
    page,
    pageSize,
    authToken,
    deviceId
}) => {
    // export const pointsVoucherRedemption1ReportApi = (data) => {
    if (authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (page > 0) {
            mulai = pageSize + 1;
            baris = 0;
            for (var i = 0; i <= page; ) {
                baris = pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURLNew + "report/points-voucher-redemption-one",
            params: {
                memberId: userId,
                merchantId: merchantId,
                startDate: startDate,
                endDate: endDate,
                offset: mulai,
                pageSize: pageSize,
                page: page,
                nRecords: pageSize,
                rmNumber: accountNumber
            },
            data: {},
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const pointsVoucherRedemption2ReportApi = ({
    userId,
    merchantId,
    accountNumber,
    startDate,
    endDate,
    page,
    pageSize,
    authToken,
    deviceId
}) => {
    // export const pointsVoucherRedemption2ReportApi = (data) => {
    if (authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (page > 0) {
            mulai = pageSize + 1;
            baris = 0;
            for (var i = 0; i <= page; ) {
                baris = pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURLNew + "report/points-voucher-redemption-two",
            params: {
                memberId: userId,
                merchantId: merchantId,
                startDate: startDate,
                endDate: endDate,
                offset: mulai,
                pageSize: pageSize,
                page: page,
                nRecords: pageSize,
                rmNumber: accountNumber
            },
            data: {},
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const memberDelinquencyApi = ({
    userId,
    merchantId,
    page,
    pageSize,
    authToken,
    deviceId,
    startDate,
    endDate,
    startDateTaggedAsDelinquent,
    endDateTaggedAsDelinquent,
    vybeClientName,
    rmNumber
}) => {
    if (authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (page > 0) {
            mulai = pageSize + 1;
            baris = 0;
            for (var i = 0; i <= page; ) {
                baris = pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "GET",
            url: window.ApiURL + "report/501/deliquency/getDeliquentReport",
            params: {
                vybeClientName: vybeClientName,
                rmNumber: rmNumber,
                startDate: startDate,
                endDate: endDate,
                startDateTaggedAsDelinquent: startDateTaggedAsDelinquent,
                endDateTaggedAsDelinquent: endDateTaggedAsDelinquent,
                merchantId: merchantId,
                userId: userId,
                page: page,
                nRecords: pageSize,
                pageSize: pageSize,
                offset: mulai
            },
            data: {},
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const reportCCApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/product-cc",
            params: {
                memberId: data.userId,
                merchantId: data.merchantId,
                memberName: data.memberName,
                rewardName: data.rewardName,
                rmNumber: data.rmNumber,
                customerNumber: data.customerNumber,
                startDate: data.startDate,
                endDate: data.endDate,
                offset: mulai,
                pageSize: data.pageSize,
                page: data.page,
                nRecords: data.pageSize
            },
            data: {},
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const ownVoucherApi = data => {
    if (data.authToken != null) {
        var mulai = 0;
        var baris = 10;

        if (data.page > 0) {
            mulai = data.pageSize + 1;
            baris = 0;
            for (var i = 0; i <= data.page; ) {
                baris = data.pageSize + baris;
                i++;
            }
            mulai = baris - 10;
        }
        return Axios({
            method: "get",
            url: window.ApiURL + "report/own-voucher",
            params: {
                memberId: data.userId,
                merchantId: data.merchantId,
                memberName: data.memberName,
                status: data.status,
                offset: mulai,
                pageSize: data.pageSize,
                page: data.page,
                nRecords: data.pageSize,
                isOwnProduct: data.isOwnProduct,
                voucherName: data.voucherName,
                voucherPrice: data.voucherPrice,
                expiryStartDate: data.expiryStartDate,
                expiryEndDate:
                    data.expiryEndDate === "Invalid date" ||
                    data.expiryEndDate === null ||
                    data.expiryEndDate === undefined
                        ? ""
                        : data.expiryEndDate,
                promoStartDate: data.promoStartDate,
                promoEndDate: data.promoEndDate
            },
            data: {},
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const getHistoryDownloadApi = ({
    userId,
    merchantId,
    status,
    reportType,
    startDate,
    endDate,
    pageSize,
    page,
    authToken,
    deviceId
}) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v1/job-report",
            params: {
                page: page,
                pageSize: pageSize,
                memberId: userId || "",
                merchantId: merchantId || "",
                statusCode: status || "",
                reportTypeCode: reportType || "",
                startDate: startDate || "",
                endDate: endDate || "",
                sorts: "submittedTime:desc"
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId || "Portal"
            }
        });
    }
    return Promise.reject(new Error("Auth token is missing"));
};

export const createDownloadJobApi = ({
    merchantId,
    memberId,
    reportType,
    filters,
    startDate,
    endDate,
    authToken,
    deviceId = "Portal"
}) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURL + "report/v1/job-report",
            data: {
                merchantId: merchantId || "",
                memberId: memberId || "",
                reportTypeCode: reportType || "",
                filters: filters || "",
                startDate: startDate || "",
                endDate: endDate || ""
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
                "Content-Type": "application/json"
            }
        });
    }
    return Promise.reject(new Error("Auth token is missing"));
};

export const downloadHistoryFileApi = ({ jobId, authToken, deviceId }) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v1/job-report/" + jobId,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId || "Portal"
            }
        });
    }
};

export const getCompleteCountApi = ({ reportType, authToken, deviceId }) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURL + "report/v1/job-report/complete-count",
            params: {
                reportTypeCode: reportType || ""
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId || "Portal"
            }
        });
    }
};

export const getPointTransactionHistoryApi = ({
    memberId,
    startDate,
    endDate,
    page = 0,
    pageSize = 10,
    authToken,
    deviceId
}) => {
    const token = authToken || localStorage.getItem("a");
    const devId = deviceId || localStorage.getItem("d") || "Portal";
    if (token != null) {
        return Axios({
            method: "get",
            url: window.ApiURL + "point/v1/point/" + memberId + "/history",
            params: {
                startDate: startDate || "",
                endDate: endDate || "",
                page,
                pageSize
            },
            headers: {
                authToken: token,
                deviceUniqueId: devId,
                Accept: "application/json, text/plain, */*"
            }
        });
    }
};
